function FormHelper($scope) {

    this.ResetFormErrors = function () {
        $scope.FormSent = null;
        $scope.formError = '';
        $scope.scheduleError = '';
    }
}